import { io, Socket } from 'socket.io-client';
import { ChatMessage, LocationUpdate, EmergencyBroadcast, Responder } from '../types';

export class SocketManager {
  private socket: Socket | null = null;
  private isConnected = false;

  constructor() {
    this.connect();
  }

  private connect(): void {
    // In a real implementation, this would connect to your WebSocket server
    // For demo purposes, we'll simulate the connection
    this.socket = io('ws://localhost:3001', {
      autoConnect: false
    });

    // Simulate connection for demo
    this.isConnected = true;
    console.log('Socket connected (simulated)');
  }

  // Chat functionality
  sendChatMessage(message: ChatMessage): void {
    if (this.isConnected) {
      console.log('Sending chat message:', message);
      // this.socket?.emit('chat-message', message);
    }
  }

  onChatMessage(callback: (message: ChatMessage) => void): void {
    // this.socket?.on('chat-message', callback);
    console.log('Chat message listener registered');
  }

  // Location tracking
  sendLocationUpdate(update: LocationUpdate): void {
    if (this.isConnected) {
      console.log('Sending location update:', update);
      // this.socket?.emit('location-update', update);
    }
  }

  onLocationUpdate(callback: (update: LocationUpdate) => void): void {
    // this.socket?.on('location-update', callback);
    console.log('Location update listener registered');
  }

  // Emergency broadcasts
  sendEmergencyBroadcast(broadcast: EmergencyBroadcast): void {
    if (this.isConnected) {
      console.log('Sending emergency broadcast:', broadcast);
      // this.socket?.emit('emergency-broadcast', broadcast);
    }
  }

  onEmergencyBroadcast(callback: (broadcast: EmergencyBroadcast) => void): void {
    // this.socket?.on('emergency-broadcast', callback);
    console.log('Emergency broadcast listener registered');
  }

  // Responder availability
  updateResponderAvailability(responderId: string, availability: Responder['availability']): void {
    if (this.isConnected) {
      console.log('Updating responder availability:', { responderId, availability });
      // this.socket?.emit('responder-availability', { responderId, availability });
    }
  }

  onResponderAvailabilityChange(callback: (data: { responderId: string; availability: Responder['availability'] }) => void): void {
    // this.socket?.on('responder-availability-change', callback);
    console.log('Responder availability listener registered');
  }

  // WebRTC signaling
  sendWebRTCSignal(signal: any): void {
    if (this.isConnected) {
      console.log('Sending WebRTC signal:', signal);
      // this.socket?.emit('webrtc-signal', signal);
    }
  }

  onWebRTCSignal(callback: (signal: any) => void): void {
    // this.socket?.on('webrtc-signal', callback);
    console.log('WebRTC signal listener registered');
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.isConnected = false;
    }
  }

  isSocketConnected(): boolean {
    return this.isConnected;
  }
}